// An empty image place (source `placeholder`, contract 2.10.0), drawn as Canva draws its
// frames: a small landscape (sky, sun, a cloud and two hills) that fills the box, or a
// head-and-shoulders silhouette for the creator's avatar. Vector, so it stays sharp at
// every scale; the stage, the thumbnails and the export all paint it the same way.
const SKY = ['#cfe3f7', '#eef6fd'];
const HILLS = ['#c8dca4', '#97b866'];
const AVATAR = { back: '#dde3ea', figure: '#ffffff' };

function landscape(ctx, width, height) {
  const sky = ctx.createLinearGradient(0, 0, 0, height);
  sky.addColorStop(0, SKY[0]);
  sky.addColorStop(1, SKY[1]);
  ctx.fillStyle = sky;
  ctx.fillRect(0, 0, width, height);
  // Sun and cloud keep their shape in any box: sized and spaced by its shorter side.
  const unit = Math.min(width, height);
  ctx.fillStyle = 'rgba(255, 255, 255, 0.95)';
  ctx.beginPath();
  ctx.arc(width - unit * 0.24, Math.min(height * 0.24, unit * 0.3), unit * 0.07, 0, Math.PI * 2);
  ctx.fill();
  const cx = unit * 0.3;
  const cy = Math.min(height * 0.3, unit * 0.38);
  ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
  [[-0.07, 0.01, 0.05], [0, -0.015, 0.07], [0.07, 0.01, 0.045]].forEach(([x, y, r]) => {
    ctx.beginPath();
    ctx.arc(cx + unit * x, cy + unit * y, unit * r, 0, Math.PI * 2);
    ctx.fill();
  });
  ctx.fillRect(cx - unit * 0.07, cy + unit * 0.01, unit * 0.14, unit * 0.05);
  ctx.fillStyle = HILLS[0];
  ctx.beginPath();
  ctx.moveTo(0, height * 0.74);
  ctx.quadraticCurveTo(width * 0.42, height * 0.56, width, height * 0.7);
  ctx.lineTo(width, height);
  ctx.lineTo(0, height);
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = HILLS[1];
  ctx.beginPath();
  ctx.moveTo(0, height * 0.88);
  ctx.quadraticCurveTo(width * 0.62, height * 0.68, width, height * 0.84);
  ctx.lineTo(width, height);
  ctx.lineTo(0, height);
  ctx.closePath();
  ctx.fill();
}

function silhouette(ctx, width, height) {
  ctx.fillStyle = AVATAR.back;
  ctx.fillRect(0, 0, width, height);
  const unit = Math.min(width, height);
  ctx.fillStyle = AVATAR.figure;
  ctx.beginPath();
  ctx.arc(width / 2, height * 0.4, unit * 0.19, 0, Math.PI * 2);
  ctx.fill();
  ctx.beginPath();
  ctx.ellipse(width / 2, height * 0.98, unit * 0.36, unit * 0.32, 0, 0, Math.PI * 2);
  ctx.fill();
}

// Paints into a box already clipped to its outline, at the layer's origin.
export function drawPlaceholder(ctx, width, height, { avatar = false } = {}) {
  ctx.save();
  if (avatar) silhouette(ctx, width, height);
  else landscape(ctx, width, height);
  ctx.restore();
}
